import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  beforeCreate () {
    const {
      gettersMap,
      actionsMap,
      mutationsMap
    } = this.$vnode.componentOptions.Ctor.options
    const translationId = this.$options.propsData.translationId
    const namespace = `trader_id_${translationId}`

    const mutations = {}
    const getters = {}
    const actions = {}

    if (gettersMap) {
      gettersMap.forEach(item => getters[item] = `${namespace}/${item}`)
    }

    if (actionsMap) {
      actionsMap.forEach(item => actions[item] = `${namespace}/${item}`)
    }

    if (mutationsMap) {
      Object.keys(mutationsMap).forEach(key => {
        mutations[key] = `${namespace}/${mutationsMap[key]}`
      })
    }

    this.$options.computed = {
      ...(this.$options.computed || {}),
      ...mapGetters(getters)
    }
    this.$options.methods = {
      ...(this.$options.methods || {}),
      ...mapActions(actions),
      ...mapMutations(mutations)
    }
  }
}
